// extracted by mini-css-extract-plugin
export default {"dotContainer":"ncfYGz","isActive":"RytQHJ","dot":"hTokVI"};